import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { Tab, Tabs } from "nlib/ui";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Modal from "nlib/ui/Modal";
import React, { useState } from "react";
import SelectDocumentTab from "./lib/SelectDocumentTab";
import UploadDocumentTab from "./lib/UploadDocumentTab";

const TABS = {
  SELECT: "select",
  UPLOAD: "upload"
};

const PairDocumentsWindow = ({ transaction, onClose }) => {
  const { uiTexts } = useSelector(getTextsData);

  const [currentTab, setCurrentTab] = useState(TABS.SELECT);

  return (
    <Modal
      iconComponent={Icons.FileText}
      title={uiTexts.matchDocuments}
      className={Css.pairDocumentsWindow}
      dialogClassName={Css.modalDialog}
      onClose={onClose}>
      <div className={Css.contentWrap}>
        <Tabs className={Css.tabs} current={currentTab} onChange={setCurrentTab}>
          <Tab value={TABS.SELECT}>
            <Icons.ListMagnifyingGlass />
            <span>{uiTexts.selectFromList}</span>
          </Tab>
          <Tab value={TABS.UPLOAD}>
            <Icons.Upload />
            <span>{uiTexts.uploadNew}</span>
          </Tab>
        </Tabs>
        {(() => {
          switch (currentTab) {
            case TABS.SELECT:
              return <SelectDocumentTab transaction={transaction} onSelect={onClose} />;
            case TABS.UPLOAD:
              return <UploadDocumentTab onDropFile={onClose} />;
            default:
              return null;
          }
        })()}
      </div>
    </Modal>
  );
};

export default React.memo(PairDocumentsWindow);
